import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/core/services/config.service';
import { Observable, of } from 'rxjs';
import { LoadSummaryView } from '../models/load.model';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '../models/api.model';
@Injectable()
export class ShipmentApiService {
  constructor(
    private config: ConfigService,
    private http: HttpClient
  ) {}

  private async getApiUrl(): Promise<string> {
    const envConfig = await this.config.getConfig();
    return envConfig.runtime.userManagementApiUrl;
  }

  public async getLoadSummary() {
    return this.getLoadSummaryApiCall().toPromise();
  }
  public getLoadSummaryApiCall(): Observable<ApiResponse<LoadSummaryView[]>> {
    return of({
      data: [
      {
        id: '900365759',
        destination: {
          city: 'HIGHLAND PARK',
          state: 'MI',
          loading_type: 'S',
          from_date_time: '2020-07-09T00:01:01.000',
          to_date_time: '2020-07-10T00:01:01.000'
        },
        equipmentType: 'DRY53 VAN',
        origin: {
          city: 'LEXINGTON',
          state: 'KY',
          loading_type: 'S',
          from_date_time: '2020-07-05T12:00:00.000-05:00',
          to_date_time : '2020-07-05T15:00:00.000'
        },
        weight: 42355,
        miles: 400
      },
      {
        id: '900365760',
        destination: {
          city: 'Butler',
          state: 'IN',
          loading_type: 'D',
          from_date_time: '2020-07-09T00:01:01.000',
          to_date_time: '2020-07-10T00:01:01.000'
        },
        equipmentType: 'DRY53 VAN',
        origin: {
          city: 'TOLEDO',
          state: 'OH',
          loading_type: 'D',
          from_date_time: '2020-07-05T12:00:00.000-05:00',
          to_date_time : '2020-07-05T15:00:00.000'
        },
        weight: 42355,
        miles: 400
      },
      {
        id: '900365760',
        destination: {
          city: 'Butler',
          state: 'IN',
          loading_type: 'D',
          from_date_time: '2020-07-09T00:01:01.000',
          to_date_time: '2020-07-10T00:01:01.000'
        },
        equipmentType: 'DRY53 VAN',
        origin: {
          city: 'TOLEDO',
          state: 'OH',
          loading_type: 'D',
          from_date_time: '2020-07-05T12:00:00.000-05:00',
          to_date_time : '2020-07-05T15:00:00.000'
        },
        weight: 42355,
        miles: 400
      },
      {
        id: '900365760',
        destination: {
          city: 'Butler',
          state: 'IN',
          loading_type: 'D',
          from_date_time: '2020-07-09T00:01:01.000',
          to_date_time: '2020-07-10T00:01:01.000'
        },
        equipmentType: 'DRY53 VAN',
        origin: {
          city: 'TOLEDO',
          state: 'OH',
          loading_type: 'D',
          from_date_time: '2020-07-05T12:00:00.000-05:00',
          to_date_time : '2020-07-05T15:00:00.000'
        },
        weight: 42355,
        miles: 400
      },
      {
        id: '900365760',
        destination: {
          city: 'Butler',
          state: 'IN',
          loading_type: 'D',
          from_date_time: '2020-07-09T00:01:01.000',
          to_date_time: '2020-07-10T00:01:01.000'
        },
        equipmentType: 'DRY53 VAN',
        origin: {
          city: 'TOLEDO',
          state: 'OH',
          loading_type: 'D',
          from_date_time: '2020-07-05T12:00:00.000-05:00',
          to_date_time : '2020-07-05T15:00:00.000'
        },
        weight: 42355,
        miles: 400
      },
      {
        id: '900365760',
        destination: {
          city: 'Butler',
          state: 'IN',
          loading_type: 'D',
          from_date_time: '2020-07-09T00:01:01.000',
          to_date_time: '2020-07-10T00:01:01.000'
        },
        equipmentType: 'DRY53 VAN',
        origin: {
          city: 'TOLEDO',
          state: 'OH',
          loading_type: 'D',
          from_date_time: '2020-07-05T12:00:00.000-05:00',
          to_date_time : '2020-07-05T15:00:00.000'
        },
        weight: 42355,
        miles: 400
      },
      {
        id: '900365760',
        destination: {
          city: 'Butler',
          state: 'IN',
          loading_type: 'D',
          from_date_time: '2020-07-09T00:01:01.000',
          to_date_time: '2020-07-10T00:01:01.000'
        },
        equipmentType: 'DRY53 VAN',
        origin: {
          city: 'TOLEDO',
          state: 'OH',
          loading_type: 'D',
          from_date_time: '2020-07-05T12:00:00.000-05:00',
          to_date_time : '2020-07-05T15:00:00.000'
        },
        weight: 42355,
        miles: 400
      }
      ],
      meta: {
        limit: 10,
        offset: 0,
        total: 2
      }
    });
    // return this.http.get(`${this.getApiUrl}/orders`);
  }
}
